import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import * as z from 'zod'
import { getDocumentDetails } from '~bank-documents/service/documentDetails'

const sch = z.object({
  historyPage: z.number().int().positive().optional(),
  historySize: z.number().int().positive().optional()
})

export const documentDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$documentId',
    // for future versions on tanstack-router
    // params: {
    //   parse: (params) => ({
    //     documentId: z.number().int().parse(Number(params?.documentId))
    //   }),
    //   stringify: ({ documentId }) => ({ documentId: `${documentId}` })
    // },
    validateSearch: (search) => sch.parse(search),
    loaderDeps: ({ search: { historyPage, historySize } }) => ({ historyPage, historySize }),
    beforeLoad: ({ params }) => {
      if ('documentId' in params) return { id: Number(params.documentId) }
      else throw new NotFoundError()
    },
    loader: ({ context: { id }, deps }) =>
      getDocumentDetails({
        id: id,
        historyPage: deps.historyPage,
        historySize: deps.historySize
      }),
    gcTime: 0,
    pendingMs: 0,
    component: lazyRouteComponent(() => import('./DocumentDetails'))
  })
